import Vue from 'vue'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

const state = {
    // form
    targetId: Constants.RegisterHash,
    values: {},

    // model
    serviceModel: [],
    partnerService: '',
    partnerName: null,
    partnerMail: null,
    partnerStatus: ''
}

const getters = {
    get: state => state,

    // form mode
    isRegister: state => state.targetId === Constants.RegisterHash,
    isModify: state => state.targetId !== Constants.RegisterHash,

    // 登録値を表示用に変換
    getValue: state => (key) => {
        try {
            let value = state.values[key]
            switch (key) {
                default:
                    return value
            }
            /* eslint-disable no-new */
        } catch (e) {
            return ''
        }
    }
}

const actions = {
    /**
     * 初期読出し
     */
    loadModel({commit}, {targetId, partnerParams, serviceParams, serviceDetailParams}) {
        commit('setTargetId', targetId)

        return new Promise((resolve, reject) => {
            const isAdmin = this.getters['auth/isAdmin']

            const types = []
            const methods = []
            const parameters = []

            // システム管理者の場合
            if (isAdmin) {
                types.push('service')
                methods.push('v1ServiceListGet')
                parameters.push(serviceParams)
                // サービス運用者の場合
            } else {
                types.push('service')
                methods.push('v1ServiceDetailGet')
                parameters.push(serviceDetailParams)
            }

            if (getters.isModify(state)) {
                types.push('partner')
                methods.push('v1PartnerDetailGet')
                parameters.push(partnerParams)
            }

            if (getters.isRegister(state)) {
                // データを読出し
                ApiManager.request(types, methods, parameters)
                    .then(res => {
                        let status = Utility.parseResponse(res)
                        if (status.result) {
                            commit('inited', {})
                            if (isAdmin) {
                                commit('setServiceModel', res[0].data.serviceInfo)
                                console.log('serviceModel', state.serviceModel)
                            } else {
                                commit('setServiceDetailModel', res[0].data.serviceBasicInfo)
                                console.log('serviceDetailModel', state.serviceDetailModel)
                                const serviceUuid = this.getters['auth/userServiceUuid']
                                commit('setInputValue', {
                                    key: 'inpService',
                                    value: serviceUuid
                                })
                            }
                            resolve()

                        } else if (status.error) {
                            // エラーメッセージ表示
                            reject(res)
                        } else {
                            // アプリケーションエラー表示
                            reject(null)
                        }
                    })
                    .catch(error => {
                        // アプリケーションエラー表示
                        reject(null)
                    })
            } else {
                // データを読出し
                ApiManager.request(types, methods, parameters)
                    .then(res => {
                        let status = Utility.parseResponse(res)
                        if (status.result) {
                            if (isAdmin) {
                                commit('setServiceModel', res[0].data.serviceInfo)
                                console.log('serviceModel', state.serviceModel)
                            } else {
                                commit('setServiceDetailModel', res[0].data.serviceBasicInfo)
                                console.log('serviceDetailModel', state.serviceDetailModel)

                                const serviceUuid = this.getters['auth/userServiceUuid']
                                commit('setInputValue', {
                                    key: 'inpService',
                                    value: serviceUuid
                                })
                            }
                            commit('inited', res[1].data.partner)
                            commit('setPartnerService', res[1].data.partner.serviceUuid)
                            commit('setPartnerName', res[1].data.partner.partnerName)
                            commit('setPartnerMail', res[1].data.partner.email)
                            commit('setPartnerStatus', res[1].data.partner.status)
                            resolve()

                        } else if (status.error) {
                            // エラーメッセージ表示
                            reject(res)
                        } else {
                            // アプリケーションエラー表示
                            reject(null)
                        }
                    })
                    .catch(error => {
                        // アプリケーションエラー表示
                        reject(null)
                    })
            }


        })
    },

    /**
     * リセット
     */
    reset({commit}) {
        commit('reset')
    }
}

const mutations = {
    // init
    inited(state, data) {
        Vue.set(state, 'values', data)
        Vue.set(state.values, 'serviceUuid', getters.isRegister(state) ? '' : data.serviceUuid)
        Vue.set(state.values, 'partnerName', getters.isRegister(state) ? null : data.partnerName)
        Vue.set(state.values, 'email', getters.isRegister(state) ? null : data.email)
        Vue.set(state.values, 'status', getters.isRegister(state) ? 1 : data.status)
    },

    // model
    setServiceModel(state, data) {
        Vue.set(state, 'serviceModel', data)
    },
    setPartnerService(state, data) {
        Vue.set(state, 'partnerService', data)
    },
    setPartnerName(state, data) {
        Vue.set(state, 'partnerName', data)
    },
    setPartnerMail(state, data) {
        Vue.set(state, 'partnerMail', data)
    },
    setPartnerStatus(state, data) {
        Vue.set(state, 'partnerStatus', data)
    },

    // form
    setTargetId(state, targetId) {
        state.targetId = targetId
    },
    setValues(state, values) {
        Vue.set(state, 'values', values)
    },
    setInputValue(state, {key, value}) {
        Vue.set(state.values, key, value)
    },

    // reset
    reset(state) {
        state.targetId = Constants.RegisterHash
        Vue.set(state, 'values', {})
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
